<template>
  <div>
    <div class="white-card card-price">
      <div v-for="(element, index) in prices" :key="index">
        <div class="p-3" v-if="!element.isTotal">
          <section-card-price :element="element"></section-card-price>
        </div>
        <div class="separator mx-3" v-if="index < prices.length-2">
        </div>
      </div>
    </div>
    <div class="blue-background">
      <div v-for="(element, index) in prices" :key="index">
        <div v-if="element.isTotal" class="p-3">
          <section-card-price :element="element"></section-card-price>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import SectionCardPrice from "./SectionCardPrice.vue";

export default {
  name: "OperationBilanCardPrice",

  components: {
    SectionCardPrice
  },

  props: {
    prices: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.separator {
  border: var(--main-grey) 1px solid;
}

.blue-background {
  background-color: var(--main-blue-light);
}

.card-price {
  max-height: 52vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanCreateEditSteps/components/OperationBilanCardPrice.vue